<template>
  <div :class="{contentWrap:true,noNav:$store.state.isWx}">
    <div class="container">
      <van-nav-bar :title="title" v-if="!$store.state.isWx" fixed />
      <scroll>
        <van-tabs v-model="typeRadio" swipeable class="clear chosetype">
          <van-tab title="单位">
            <van-cell-group>
              <van-field
                label="联系号码"
                v-model="inputinfo.phone"
                placeholder="请输入联系号码"
                type="tel"
                :error-message="inputinfo.phoneerror"
                clearable
                @blur.stop="vertifyphone"
                class="pdt-3 pdb-3"
              />
              <van-field
                label="纳税识别号"
                v-model="inputinfo.number"
                placeholder="请输入单位纳税识别号"
                clearable
                class="pdt-3 pdb-3"
              />
            </van-cell-group>
          </van-tab>

          <van-tab title="个人">
            <van-cell-group>
              <van-field
                label="联系号码"
                v-model="inputinfo.phone"
                placeholder="请输入联系号码"
                type="tel"
                :error-message="inputinfo.phoneerror"
                clearable
                @blur.stop="vertifyphone"
                class="pdt-3 pdb-3"
              />
              <van-field
                label="发票抬头"
                v-model="inputinfo.name"
                placeholder="请输入抬头"
                clearable
                class="pdt-3 pdb-3"
              />
            </van-cell-group>
          </van-tab>
        </van-tabs>

        <div class="buttonWrap">
          <van-button type="primary" @click.stop="toSearchResult">查询</van-button>
        </div>

        <div class="copyright">
          <p>Copyright(C) 2020－2021 ectrip.com All Rights Reserved.</p>
          <p>发票服务热线：0514-87357803</p>
          <p>
            技术支持：
            <a target="_blank" href="//www.ectrip.com">鼎游信息</a>
          </p>
        </div>
      </scroll>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "InvoiceSearch",
  data() {
    return {
      typeRadio: 0,
      title: this.$route.meta.title,
      inputinfo: {
        phone: "",
        phoneok: false,
        number: "",
        name: "",
        phoneerror: "",
      },
      show: true,
    };
  },
  methods: {
    // 验证手机号
    vertifyphone() {
      if (this.inputinfo.phone === "") {
        this.inputinfo.phoneerror = "联系号码不能为空";
        this.inputinfo.phoneok = false;
      } else {
        this.inputinfo.phoneerror = "";
        this.inputinfo.phoneok = true;
      }
    },
    toSearchResult() {
      if (this.typeRadio === 0) {
        if (this.inputinfo.phoneok === true && this.inputinfo.number !== "") {
          this.$router.push({
            name: "invoiceList",
            query: {
              phone: this.inputinfo.phone,
              number: this.inputinfo.number,
              typeRadio: this.typeRadio,
            },
          });
        } else {
          Toast.fail({ duration: 1000, message: "信息有误" });
        }
      } else if (this.typeRadio === 1) {
        if (this.inputinfo.phoneok === true && this.inputinfo.name !== "") {
          this.$router.push({
            name: "invoiceList",
            query: {
              phone: this.inputinfo.phone,
              username: this.inputinfo.name,
              typeRadio: this.typeRadio,
            },
          });
        } else {
          Toast.fail({ duration: 1000, message: "信息有误" });
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.all {
  font-size: 0.28rem;
}

.chosetype {
  line-height: 0.5rem;
  vertical-align: top;
}

.choseradio {
  margin-left: 0.35rem;
}

.tipstext {
  font-size: 0.2rem;
  color: #9CA5A9;
  text-align: center;
  line-height: 0.45rem;
  padding: 0.2rem 0.1rem;
}

.copyright {
  margin-top: 0.3rem;
  padding-top: 0.1rem;
  border-top: 0.02rem solid #D7D7D7;
  font-size: 0.2rem;
  color: #9CA5A9;
  text-align: center;
  line-height: 0.45rem;
}
</style>



// WEBPACK FOOTER //
// src/page/InvoiceSearch.vue